<template>
  <div class="developer-features-card">
    <div
      v-for="(featureGroup, index) in featureGroups"
      :key="index"
      class="developer-features-card__group"
    >
      <div
        v-if="readonly && featureGroup.data && featureGroup.data.length || !readonly"
        class="developer-features-card__group-content"
      >
        <h3 class="developer-features-card__group-title">
          {{ featureGroup.name }}
        </h3>
        <v-input
          :hide-details="!isValidationMessagesVisibile || !requiredFeatureGroups[index]"
          :error-messages="['Required']"
        >
          <FeaturesList
            v-if="featureGroup.data && featureGroup.data.length"
            :features="featureGroup.data"
            :primary="featureGroup.primary"
            :editable="!readonly"
            @edit="showEditFeaturesModal(featureGroup)"
          />
          <EmptyState
            v-else
            :title="featureGroup.emptyTitle"
            :description="featureGroup.emptyDescription"
            outlined
            @click="showEditFeaturesModal(featureGroup)"
          />
        </v-input>
      </div>
    </div>
  </div>
</template>

<script>
import FeaturesList from '@/components/Developers/Show/FeaturesList.vue';
import EmptyState from '@/components/Developers/Show/EmptyState.vue';

export default {
  components: {
    FeaturesList,
    EmptyState,
  },

  props: {
    featureGroups: {
      type: Array,
      required: true,
    },

    separated: {
      type: Boolean,
      required: false,
      default: false,
    },

    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      isValidationMessagesVisibile: false,
    };
  },

  computed: {
    isValid() {
      return this.requiredFeatureGroups.every((requiredState) => !requiredState);
    },

    requiredFeatureGroups() {
      return this.featureGroups
        .map((featureGroup) => featureGroup.required && featureGroup.data.length === 0);
    },
  },

  methods: {
    validateGroups() {
      this.isValidationMessagesVisibile = true;
      return this.isValid;
    },

    showEditFeaturesModal(featureType) {
      this.$emit('edit', featureType);
    },
  },
};
</script>

<style lang="scss" scoped>
.developer-features-card {
  margin-bottom: 24px;
  padding: 16px 24px;
  background: #FFFFFF;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 8px;

  &__group {
    margin-bottom: 12px;
    &:last-child {
      margin-bottom: 0px;
    }
  }

  &__group-title {
    color: $main--headers;
    font-size: 18px;
    font-weight: 500;
    line-height: 21px;
    margin-bottom: 8px;
  }
}
</style>
